import styled from 'styled-components';

import Button from '@atlaskit/button';

export const PurpleButtonStyled = styled(Button)`
  &&& {
    color: var(--ds-text-inverse, var(--ds-fb-text-inverse)) !important;
    background: var(
      --ds-background-accent-purple-bolder,
      var(--ds-fb-background-accent-purple-bolder)
    );
    &:hover {
      background: var(
        --ds-border-accent-purple,
        var(--ds-fb-border-accent-purple)
      );
    }
    &:active {
      background: var(
        --ds-background-discovery-bold-pressed,
        var(--ds-fb-background-discovery-bold-pressed)
      );
    }
  }
`;
